import { Routes } from '@angular/router';
import { authGuard } from './shared/services/auth.guard';

export const routes: Routes = [
  {
    path: 'users',
    title: 'Users',
    canActivate: [authGuard],
    loadComponent: () => import('./users/components/users-list-view/users-list-view').then((m) => m.UsersListView),
  },
  {
    path: 'clients',
    title: 'Clients',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./clients/components/clients-list-view/clients-list-view').then((m) => m.ClientsListView),
  },
  {
    path: 'roles-management',
    title: 'Roles management',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./roles/components/roles-management-list-view/roles-management-list-view').then(
        (m) => m.RolesManagementListView,
      ),
  },
  {
    path: 'roles/:userId',
    title: 'Roles',
    canActivate: [authGuard],
    loadComponent: () => import('./roles/components/roles-list-view/roles-list-view').then((m) => m.RolesListView),
  },
  {
    path: 'unauthorized',
    title: 'Unauthorized',
    loadComponent: () =>
      import('./unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
  },
  {
    path: '**',
    redirectTo: 'users',
    pathMatch: 'full',
  },
];
